var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0659 9C15.3507 9 15.586 9.21165 15.6232 9.48615L15.6284 9.5625V14.8132C15.6284 16.1129 14.6111 17.1751 13.3292 17.2468L13.1909 17.2507H4.94092C3.64115 17.2507 2.57899 16.2333 2.50728 14.9515L2.50342 14.8132V9.5625C2.50342 9.25185 2.75526 9 3.06592 9C3.35069 9 3.58604 9.21165 3.62329 9.48615L3.62842 9.5625V14.8132C3.62842 15.5017 4.15875 16.0666 4.83328 16.1213L4.94092 16.1257H13.1909C13.8796 16.1257 14.4443 15.5953 14.4991 14.9208L14.5034 14.8132V9.5625C14.5034 9.25185 14.7553 9 15.0659 9ZM4.91497 6.16223L8.66213 2.41477C8.8617 2.21517 9.174 2.1969 9.3942 2.36004L9.45735 2.41442L13.2109 6.16189C13.4309 6.38137 13.4312 6.73753 13.2116 6.95738C13.0121 7.15724 12.6996 7.17565 12.4793 7.01245L12.4161 6.95803L9.62393 4.17075L9.6246 12.9412C9.6246 13.226 9.41295 13.4613 9.13845 13.4986L9.0621 13.5037C8.77733 13.5037 8.54198 13.2921 8.5047 13.0175L8.4996 12.9412L8.49893 4.1685L5.71049 6.95769C5.5108 7.1574 5.1983 7.17556 4.97809 7.01219L4.915 6.95772C4.71529 6.75803 4.69712 6.44553 4.86051 6.22531L4.91497 6.16223Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCion);
export default __webpack_public_path__ + "static/media/upload_cion.5bac57905f7ec83536db1feb9cf5780c.svg";
export { ForwardRef as ReactComponent };